import React from 'react';
import PropTypes from 'prop-types';
import { IntlProvider } from 'react-intl';
import 'focus-visible/dist/focus-visible';

import './styles.css';
import './responsive.css';
import { translationMessages } from './i18n';
import { setupMountNode } from './utils/modals';
import MainContainer from '../MicroApp/containers/MainContainer';

/** Required configuration for all root UI components, unless [config.configure()](./config.js) is called,
 *  in which case no configuration needs to be provided to the UI component itself. */
export const configPropTypes = {
  session: PropTypes.object,
  apiUrl: PropTypes.string,
  fcService: PropTypes.object,
  locale: PropTypes.string,
};

export default class EmbedFramework extends React.PureComponent {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
    ...configPropTypes,
  };

  constructor(props) {
    super(props);

    /* istanbul ignore next */
    console.log(
      'Starting Events Template UI @ %s',
      process.env.REACT_APP_GIT_COMMIT ? `${process.env.REACT_APP_GIT_COMMIT} / ${process.env.REACT_APP_GIT_BRANCH}` : 'development',
    ); // eslint-disable-line no-console

    this.contextRef = React.createRef();
  }

  componentDidMount() {
    this.cleanupMountNode = setupMountNode();
    this.props.fcService.getUserInfo().then((userInfo) => {
      if (this.state) {
        this.setState({ userInfo: JSON.stringify(userInfo) });
      }
    });
  }

  componentWillUnmount() {
    this.cleanupMountNode();
  }

  render() {
    const { locale = 'en', ...rest } = this.props;
    /* istanbul ignore next */
    const messages = translationMessages[locale] || translationMessages[locale.split('-')[0]];
    return (
      <React.Fragment>
        <div className="eventsui" ref={this.contextRef}>
          <IntlProvider key={locale} locale={locale} messages={messages}>
            <MainContainer {...rest} contextRef={this.contextRef} />
          </IntlProvider>
        </div>
      </React.Fragment>
    );
  }
}
